import { createContext, useContext, useEffect, useState } from "react";
import { useItemState } from "shared/hooks";

const ColorPickerContext = createContext();
const SwitchContext = createContext();
const ImageContext = createContext();

// provider
export const ColorPickerProvider = ({ children }) => {
	const [ColorPicker, setColorPicker] = useState(null);

	useEffect(() => {
		import("react-color").then((colorModule) => {
			setColorPicker(colorModule);
		});
	}, []);

	return <ColorPickerContext.Provider value={ColorPicker}>{children}</ColorPickerContext.Provider>;
};

export const SwitchProvider = ({ children, initialValue = false, isDisabled = false  }) => {
	const [isOpen, setIsOpen] = useState(initialValue);

	const open = () => {
		if (!isDisabled) setIsOpen(true);
		
	};
	const close = () => {
		if (!isDisabled) setIsOpen(false);
	};

    return <SwitchContext.Provider value={{ isOpen, setIsOpen, open, close }}>{children}</SwitchContext.Provider>;
};

export const useColorPicker = () => {
	return useContext(ColorPickerContext);
};

export const useSwitch = () => {
	return useContext(SwitchContext);
};

export const ImageProvider = ({ children }) => {
	const importAll = (r) => {
		let images = {};
		r.keys().forEach((item) => {
			images[item.replace("./", "")] = r(item);
		});
		return images;
	};

	// eslint-disable-next-line no-undef
	const emotions = importAll(require.context("../../Assets/images/map-emotions", false, /\.(png|jpe?g|svg)$/));
	// eslint-disable-next-line no-undef
	const icons = importAll(require.context("../../Assets/images/map-icons", false, /\.(png|jpe?g|svg)$/));

	return <ImageContext.Provider value={{ emotions, icons }}>{children}</ImageContext.Provider>;
};

export const useImages = () => useContext(ImageContext);


const ItemContext = createContext();

// Step 2: Create the Provider Component
export const ItemProvider = ({ children, initialAction, updateService }) => {
    const itemState = useItemState(initialAction, updateService);
    return (
        <ItemContext.Provider value={itemState}>
            {children}
        </ItemContext.Provider>
    );
};

// Hook to use the item state
export const useItem = () => {
    const context = useContext(ItemContext);
    if (context === undefined) {
        throw new Error('useItem must be used within an ItemProvider');
    }
    return context;
};
